import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as relatorioActions from '../../../actions/relatorioActions'
import Helpers from '../../../util/Helpers'
import $ from 'jquery';
import GrafBarraHierarquiaAssuntosEstrutura from './GrafBarraHierarquiaAssuntosEstrutura'



class TotalHierarquiaAssuntosEstruturaGrafBarra extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            idNatureza: 0,
            altura:0,
            paginacarregada: false,
            assuntoSelecionado: null,
            pesquisando: true
        };
        
        this.getAssuntoPai = this.getAssuntoPai.bind(this);
    }

   
    alerta(titulo, mensagem, tipo, posicao){
        
        // this.props.actionsAlerta.apresentarAlerta({
        //     title: titulo!==null?titulo:'Aviso!',
        //     message: mensagem!==null?mensagem:'',
        //     level: tipo!==null?tipo:'error',
        //     position: posicao!==null?posicao:'tc',
        //     showMsg: true,
        //     autoDismiss:25
        // });
    }

    getAssuntoPai(obj){
        
        if(obj!==null){
            
            //metodo da dashboard que passará o id para a modal. 
            //console.log('clicou em q gráfico ',this.props.relatorio.dado[obj[0]._index].mClassificacaoOperador);
            //this.props.obtemNaturezaSelecionada(this.props.relatorio.dado[obj[0]._index].mClassificacaoOperador)
            //window.UIModals.showModal('#visualizarRelatorio');
            this.setState({assuntoSelecionado: obj});
            
            this.setState({ pesquisando: true });
            this.props.actions.ListarAssuntosComTotalHierarquico(this.props.parametrosPesquisaRelatorio, this.props.tipicasOuvidoria, obj.mIdAssunto).then(
                () => {
                    this.setState({ pesquisando: false });
                }).catch(error =>{
                this.alerta('Erro em relatório', error , 'error', 'tc');
            });
        }
        else{
            this.setState({assuntoSelecionado: null});
            
            this.setState({ pesquisando: true });
            this.props.actions.ListarAssuntosComTotalHierarquico(this.props.parametrosPesquisaRelatorio, this.props.tipicasOuvidoria).then(
                () => {
                    this.setState({ pesquisando: false });
                }).catch(error =>{
                this.alerta('Erro em relatório', error , 'error', 'tc');
            });
        }
        
    }

   componentDidMount() {
       
        if(!$.isEmptyObject(this.props.parametrosPesquisaRelatorio)){
            
            this.setState({ pesquisando: true });
            this.props.actions.ListarAssuntosComTotalHierarquico(this.props.parametrosPesquisaRelatorio, this.props.tipicasOuvidoria).then(
                () => {
                    this.setState({ pesquisando: false });
                }).catch(error =>{
                this.alerta('Erro em relatório', error , 'error', 'tc');
            });
            //console.log(' componentDidMount - ListarTotalMensagemPorClassificacaoPorIdEstruturaPai ', this.props.parametrosPesquisaRelatorio);
        }
    }

    componentWillReceiveProps(nextProps) {
        
        if(!$.isEmptyObject(nextProps.parametrosPesquisaRelatorio)){
            
          if(this.props.parametrosPesquisaRelatorio !== nextProps.parametrosPesquisaRelatorio ){
              this.setState({ pesquisando: true });
              this.props.actions.ListarAssuntosComTotalHierarquico(nextProps.parametrosPesquisaRelatorio, nextProps.tipicasOuvidoria).then(
                  () => {
                      this.setState({ pesquisando: false });
                  }).catch(error =>{
                    this.alerta('Erro em relatório', error , 'error', 'tc');
                });
          }
        //   else{
        //     
        //     if(this.props.tipicasOuvidoria !== nextProps.tipicasOuvidoria){
        //         this.setState({ pesquisando: true });
        //         this.props.actions.ListarAssuntosComTotalHierarquico(nextProps.parametrosPesquisaRelatorio, nextProps.tipicasOuvidoria).then(
        //             () => {
        //                 this.setState({ pesquisando: false });
        //             }).catch(error =>{
        //             this.alerta('Erro em relatório', error , 'error', 'tc');
        //         });
        //     }
        //   }
        }
        // if(!$.isEmptyObject(nextProps.relatorio)){
        //     if (this.props.relatorio !== nextProps.relatorio) {
        //         this.props.relatorioAssuntoHierarquizado(nextProps.relatorio, this.state.assuntoSelecionado);  
        //     }
        // }
    }
    render() {
      
      var dataBar = null;
     console.log('Grafico ASSUNTO this.props.relatorio - ', this.props.relatorio)

      if ($.isEmptyObject(this.props.relatorio)) {
          return <div className='row loading'> <div className="col-lg-12 col-md-12 col-xs-12"><div className="dots-loader">Pesquisando...</div></div></div>
      }
      if(this.props.relatorio.dado===null){
          return <div className='col-centered'><h4>Não existem manifestações neste período.</h4></div>
      }

    //   if(this.props.relatorio.dado.length===0){
    //       return <div className='col-centered'><h4>Não existe sub assunto do assunto - <strong>{this.state.assuntoSelecionado.mDescricao}</strong>.</h4></div>
    //   }
 
    var relat = {dado:[]};

    var valorTotal = 0
    if(this.props.relatorio.dado.length>0){
        for(var i = 0, len = this.props.relatorio.dado.length; i < len; i++) {
            valorTotal += this.props.relatorio.dado[i].mTotalHierarquico; 
        }
        if(this.props.relatorio.dado.length>10){
            //var remover = this.props.relatorio.dado.length - 10;
            relat = {dado:this.props.relatorio.dado.slice( 0, 10 )};
            var totalSplit = 0;
            for(var i = 0, len = relat.dado.length; i < len; i++) {
                totalSplit += relat.dado[i].mTotalHierarquico; 
            }
    
            var outrosAssuntos = valorTotal - totalSplit;
            var assunto = {mTotalHierarquico:outrosAssuntos, mDescricao: "Demais assuntos" }
            relat.dado.push(assunto);
        }else{
            relat = this.props.relatorio;
        }

         
            dataBar = {
                labels: relat.dado.map(item => {
                    
                    return item.mDescricao 
                }),
                datasets: [{
                    data: relat.dado.map(item => {
                        return item.mTotalHierarquico
                    }),
                    datalabels: {
                        align: 'end',
                        anchor: 'end',
                        offset :1
                    },
                    label: 'Quantidade:',
                    borderWidth: 1,
                    //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    //hoverBorderColor: 'rgba(255,99,132,1)',
                    backgroundColor: relat.dado.map(item => {
                                        return Helpers.obterCoresNaturezaRGBa(item.mDescricao, '0.8') //+ ' - ' + item.mTotalMensagens 
                                    }),
                    borderColor: relat.dado.map(item => {
                                        return Helpers.obterCoresNaturezaRGBa(item.mDescricao, '0.1') //+ ' - ' + item.mTotalMensagens 
                                    }),
                    hoverBackgroundColor: relat.dado.map(item => {
                                        return Helpers.obterCoresNaturezaRGBa(item.mDescricao, '0.9') //+ ' - ' + item.mTotalMensagens 
                                    }),
                    hoverBorderColor: relat.dado.map(item => {
                                        return Helpers.obterCoresNaturezaRGBa(item.mDescricao, '1') //+ ' - ' + item.mTotalMensagens 
                                    }),
                    }]
            
            };
    }
     return (
        <div>
            <GrafBarraHierarquiaAssuntosEstrutura relatorio={relat} assuntoSelecionado={this.getAssuntoPai} apresentarAssunto={this.state.assuntoSelecionado} dataBar={dataBar}  nomeGrafico={this.props.nomeGrafico} efetuarCruzamento={this.props.efetuarCruzamento} />
        </div>
        
    );
  }
}
TotalHierarquiaAssuntosEstruturaGrafBarra.protoType = {
    actions: PropTypes.object.isRequired,
    relatorio: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    
    return {
            relatorio: state.relatorioHierarquiaAssunto
    };
}

function mapDispatchToProps(dispatch){
    return {
        actions: bindActionCreators(relatorioActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TotalHierarquiaAssuntosEstruturaGrafBarra);


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/Assunto/hierarquia/TotalHierarquiaAssuntosEstruturaGrafBarra.js
 **/